import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PatrimonioListarComponent } from './patrimonio-listar/patrimonio-listar.component';
import { PatrimonioInserirComponent } from './patrimonio-inserir/patrimonio-inserir.component';
import { PatrimonioEditarComponent } from './patrimonio-editar/patrimonio-editar.component';


@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: PatrimonioListarComponent},
    {path: 'inserir', data: {breadcrumb: 'Inserir'}, component: PatrimonioInserirComponent},
    {path: 'editar/:id', data: {breadcrumb: 'Editar'}, component: PatrimonioEditarComponent}
  ])],
  exports: [RouterModule]
})
export class PatrimonioRoutingModule { }
